import '../styles/PromoSection.css';

// Reusable split panel: dark icon side + light text side.
// Pass `reversed` to flip which side the visual is on.
export default function PromoSection({
  eyebrow,
  heading,
  description,
  reversed = false,
}) {
  return (
    <section className={`promo-section${reversed ? ' reversed' : ''}`}>
      <div className="promo-visual">
        <div className="promo-mark-ring">
          <BrandGlyph />
        </div>
      </div>

      <div className="promo-content">
        {eyebrow && <p className="promo-eyebrow">{eyebrow}</p>}
        <h2 className="promo-heading">{heading}</h2>
        <p className="promo-desc">{description}</p>
      </div>
    </section>
  );
}

function BrandGlyph() {
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" aria-hidden="true">
      <path
        d="M28 54a32 32 0 0 1 64 0"
        stroke="#8a8c92"
        strokeWidth="8"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M22 70l16 16 16-16 16 16 16-16"
        stroke="#8a8c92"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}